import { useTranslation } from 'react-i18next';
import { PageContainer, PageHeader } from '../../../shared_components';
import { Flex, Space, Text } from '@mantine/core';
import { Link } from 'react-router-dom';
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';

export const ReportsErrorPage = () => {
  const { t } = useTranslation(['reports', 'common']);
  return (
    <PageContainer>
      <PageHeader
        title={t('reports_error_title')}
        message={t('reports_error_message')}
      />
      <Flex direction={'row'} justify={'center'}>
        <div
          style={{
            borderRadius: '50%',
            border: '1px solid var(--mantine-color-otherGrey60-0)',
            padding: '28px',
            margin: '40px',
          }}
        >
          <div
            style={{
              boxSizing: 'content-box',
              height: '48px',
              borderRadius: '50%',
              border: '1px solid var(--mantine-color-otherGrey30-0)',
              padding: '28px',
            }}
          >
            <ReportGmailerrorredIcon sx={{ fontSize: 48 }} />
          </div>
        </div>
      </Flex>
      <Text>{t('reports_error_paragraph_1')}</Text>
      <Space h={'var(--mantine-spacing-lg)'} />
      <Text>
        {t('reports_error_paragraph_2')}{' '}
        <Link
          to={'/'}
          style={{
            color: 'var(--mantine-color-innovationPurple-0)',
            textDecoration: 'underline',
          }}
        >
          {t('support_team')}
        </Link>
      </Text>
    </PageContainer>
  );
};
